var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Image, View, Pressable } from 'react-native';
import { getTestId, isValidObject, scale, SkeletonLoader, useBreakpoint, scaledHeight } from '@airtel/air-design-system';
import { getGrowthInventoryWidgetStyles } from '../../GrowthInventoryWidgetStyles';
export var InventoryListItem = inventoryProp => {
  var _inventoryProp$testID = inventoryProp.testID,
    testID = _inventoryProp$testID === void 0 ? 'GrowthInventoryListWidgetContainer' : _inventoryProp$testID,
    id = inventoryProp.id,
    style = inventoryProp.style,
    index = inventoryProp.index,
    onUserAction = inventoryProp.onUserAction,
    onCardPressMetaData = inventoryProp.onCardPressMetaData,
    imageUrl = inventoryProp.imageUrl,
    errorImageUrl = inventoryProp.errorImageUrl,
    _inventoryProp$resize = inventoryProp.resizeMode,
    resizeMode = _inventoryProp$resize === void 0 ? 'cover' : _inventoryProp$resize,
    imageStyle = inventoryProp.imageStyle,
    _inventoryProp$useSiz = inventoryProp.useSizeScaling,
    useSizeScaling = _inventoryProp$useSiz === void 0 ? false : _inventoryProp$useSiz,
    carouselWidgetProps = inventoryProp.carouselWidgetProps,
    _inventoryProp$skipIm = inventoryProp.skipImageLoadingSkeleton,
    skipImageLoadingSkeleton = _inventoryProp$skipIm === void 0 ? false : _inventoryProp$skipIm,
    restProps = __rest(inventoryProp, ["testID", "id", "style", "index", "onUserAction", "onCardPressMetaData", "imageUrl", "errorImageUrl", "resizeMode", "imageStyle", "useSizeScaling", "carouselWidgetProps", "skipImageLoadingSkeleton"]);
  var widgetStyles = getGrowthInventoryWidgetStyles(inventoryProp);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var _useState = useState(true),
    isLoadingImage = _useState[0],
    setIsLoadingImage = _useState[1];
  var _useState2 = useState(false),
    error = _useState2[0],
    setError = _useState2[1];
  var _ref = carouselWidgetProps !== null && carouselWidgetProps !== void 0 ? carouselWidgetProps : {},
    _ref$heightConfig = _ref.heightConfig,
    heightConfig = _ref$heightConfig === void 0 ? {
      desktop: 230,
      mobile: 200
    } : _ref$heightConfig;
  var _scaledHeight = useMemo(() => {
    return useSizeScaling && scaledHeight(Number(imageStyle === null || imageStyle === void 0 ? void 0 : imageStyle.width) || 0, Number(imageStyle === null || imageStyle === void 0 ? void 0 : imageStyle.height) || 0);
  }, [imageStyle === null || imageStyle === void 0 ? void 0 : imageStyle.height, imageStyle === null || imageStyle === void 0 ? void 0 : imageStyle.width]);
  var scaledWidth = useMemo(() => {
    return useSizeScaling && scale(Number(imageStyle === null || imageStyle === void 0 ? void 0 : imageStyle.width) || 0);
  }, [imageStyle === null || imageStyle === void 0 ? void 0 : imageStyle.width]);
  var onImageLoaded = () => {
    setIsLoadingImage(false);
  };
  var onError = () => {
    setError(true);
    setIsLoadingImage(false);
  };
  return _jsx(View, Object.assign({
    style: [widgetStyles.cardContainer, style]
  }, {
    children: !!imageUrl && _jsxs(Pressable, Object.assign({
      onPress: () => {
        isValidObject(onCardPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onCardPressMetaData), {
          item: inventoryProp,
          index: index
        }));
      },
      accessible: false
    }, getTestId(testID, 'pressable'), {
      children: [!skipImageLoadingSkeleton && isLoadingImage && _jsx(SkeletonLoader, {
        width: scaledWidth || '100%',
        height: _scaledHeight || (isLargeScreen ? heightConfig === null || heightConfig === void 0 ? void 0 : heightConfig.desktop : heightConfig === null || heightConfig === void 0 ? void 0 : heightConfig.mobile),
        style: [widgetStyles.imageSkeleton, widgetStyles.imageContainer]
      }), _jsx(Image, Object.assign({}, restProps, {
        onLoadEnd: onImageLoaded,
        onError: onError,
        source: error && isValidObject(errorImageUrl) ? {
          uri: isLargeScreen ? errorImageUrl.desktop : errorImageUrl.mobile
        } : {
          uri: isLargeScreen ? imageUrl.desktop : imageUrl.mobile
        },
        resizeMode: resizeMode,
        style: [widgetStyles.imageContainer, imageStyle, _scaledHeight && {
          height: _scaledHeight
        }, scaledWidth && {
          width: scaledWidth
        }]
      }, getTestId(testID, 'image')))]
    }))
  }));
};